import JoyField from '../types/JoyField';
import JoyObjectType from '../types/objects/JoyObjectType';
import JoyMedium from '../objects/JoyMedium';
import JoyComment from '../objects/JoyComment';
import JoyDataService, { JoyDataServiceQueryOption } from '../services/JoyDataService';
import { isJoyStatusArray } from '../validation/ModelValidation';
import { isString } from '../validation/TypeChecking';
export default class JoyMediumHelper {
    /**
     * Fetch a Medium document.
     * @param id The identifier of the document to fetch.
     * @param groupId The identifier of the group to which the document belongs.
     */
    static async get(id, groupId) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.medium;
        data[JoyField.id] = id;
        data[JoyField.group] = groupId;
        let result = await JoyDataService.instance.read(data);
        try {
            return new JoyMedium(result);
        }
        catch (error) {
            throw Error('Invalid input data for JoyMedium');
        }
    }
    /**
     * Remove a Medium document.
     * @param id The identifier of the document to be removed.
     * @param groupId the identifier of the group to which the document belongs.
     */
    static async delete(id, groupId) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.medium;
        data[JoyField.id] = id;
        data[JoyField.group] = groupId;
        await JoyDataService.instance.delete(data);
        return;
    }
    /**
     * Fetch the Comment documents that belong to this medium.
     * @param mediumId Album id.
     * @param groupId Group id.
     * @param count Maximum number of documents to retrieve, 0 means all.
     */
    static async getComments(mediumId, groupId, count = 0, status) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.comment;
        data[JoyField.medium] = mediumId;
        data[JoyField.group] = groupId;
        if (isJoyStatusArray(status)) {
            data[JoyField.status] = status;
        }
        let options = new Map();
        options[JoyDataServiceQueryOption.limit] = count;
        let result = await JoyDataService.instance.read(data, options);
        let comments = [];
        for (const data of result) {
            try {
                comments.push(new JoyComment(data));
            }
            catch (error) {
                throw Error('Invalid input data for JoyComment');
            }
        }
        return comments;
    }
    /**
     * Get the identifier of an associated medium based on properties.
     * @param mediumId Album id.
     * @param groupId Group id.
     * @param properties An array of JoyProperties.
     */
    static async getMediumIdFor(mediumId, groupId, properties) {
        let data = new Map();
        data[JoyField.objectType] = JoyObjectType.medium;
        data[JoyField.medium] = mediumId;
        data[JoyField.group] = groupId;
        data[JoyField.props] = properties;
        let result = await JoyDataService.instance.read(data);
        let relatedMediumId = result[JoyField.objectId];
        if (!isString(relatedMediumId)) {
            throw Error('Invalid response data for props-related medium');
        }
        return relatedMediumId;
    }
}
//# sourceMappingURL=JoyMediumHelper.js.map